import { render, staticRenderFns } from "./nyanClock.vue?vue&type=template&id=624b2c4a&scoped=true"
import script from "./nyanClock.vue?vue&type=script&lang=js"
export * from "./nyanClock.vue?vue&type=script&lang=js"
import style0 from "./nyanClock.vue?vue&type=style&index=0&id=624b2c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624b2c4a",
  null
  
)

export default component.exports